export default __webpack_public_path__ + "static/pubsec-section-5-img-73d6180edd3d65d65612475fc290545c.png";